var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-container"},[_c('div',{staticClass:"layout-left"},[_c('div',{staticClass:"content-wrapper-layout"},[_vm._t("left")],2)]),_c('div',{staticClass:"layout-right"},[_c('div',{staticClass:"content-wrapper-layout"},[_vm._t("right")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }